<section class="flex flex-auto justify-center w-full">
    <section class="w-full">
        <div class="w-full h-[520px] bg-cover bg-no-repeat bg-center flex flex-col justify-center items-center border-b-4 border-primary" [style.backgroundImage]="'url(' + view.page.imageUrlRaw + ')'">
            <div>
                <h1 class="text-white text-center tracking-wider xl:text-8xl lg:text-6xl md:text-4xl sm:text-2xl xs:text-xl font-semibold text-shadow">{{view.page?.name}}</h1>
            </div>
           
        </div>
        <div class="w-full justify-center px-20 my-10">
            <p class="font-primary text-lg numbered-list" [innerHTML]="view.page?.rawContent"></p>
        </div>
    </section>
</section>